import type { AnalyticsSettings } from "@local-logic/core/tracking";

const ANALYTICS_DEFAULT: {
  tracker: AnalyticsSettings["tracker"];
  isDebugMode: AnalyticsSettings["isDebugMode"];
  printDebugMode: AnalyticsSettings["printDebugMode"];
} = {
  tracker: "mixpanel",
  isDebugMode: import.meta.env.MODE !== "production",
  printDebugMode: false,
};

/**
 * https://developer.mixpanel.com/reference/project-token
 *
 * Every Mixpanel project has a unique alphanumerical token for collecting data. A project's token is not a secret value.
 * In front-end implementation, such as our javascript library, this token will be available to anyone visiting your page.
 *
 * With that in mind, it is important to note that a project's token is not a form of authorization.
 * It is an identification sent along with each piece of data you send to your project.
 *
 * The settings below should correspond to Mixpanel projects, rather than specific SDKs (Hence "neighborhoodWrap")
 */
export const ANALYTICS_SETTINGS: {
  [key: string]: AnalyticsSettings;
} = {
  localContent: {
    ...ANALYTICS_DEFAULT,
    key: "14dc84d9ebfcd6747e51e28d2c22b7ad",
  },
  localDemographics: {
    ...ANALYTICS_DEFAULT,
    key: "74b752391c7469929d425547f42b2acd",
  },
  neighborhoodMatch: {
    ...ANALYTICS_DEFAULT,
    key: "e3e3ab8758f5061193fd94149288834d",
  },
  neighborhoodWrap: {
    ...ANALYTICS_DEFAULT,
    key: "e3e0bceff1412922c58657d745f9f663",
  },
  neighborhoodShowcase: {
    ...ANALYTICS_DEFAULT,
    key: "f19a8f4ceca8140edf4a693707160e6f",
  },
  neighborhoodFeatured: {
    ...ANALYTICS_DEFAULT,
    key: "171ab916e9dd5af0d41facbebfca6814",
  },
};
